<template>
  <intersect @enter="animate = true">
    <footer v-if="!this.$route.path.includes('request-call')">
      <div class="footer-top">
        <div class="container footer-content">
          <div class="around-us">
            <div class="footer-top-title font-16 tbc-bold">
              {{ $fn.tr("Navigation") }}
            </div>
            <div class="link-items">
              <template v-for="link in footerMenu('navigation')">
                <router-link
                  :to="link.full_url"
                  v-if="
                    !_.get(link, 'configs').includes('disable-from-menu') &&
                      !_.get(link, 'shortlink')
                  "
                  :key="link.id"
                  >{{ link.title }}</router-link
                >
                <a
                  :target="link.url_target"
                  :href="link.full_url"
                  v-if="
                    !_.get(link, 'configs').includes('disable-from-menu') &&
                      _.get(link, 'shortlink')
                  "
                  :key="link.id"
                  >{{ link.title }}</a
                >
              </template>
            </div>
          </div>
          <div class="around-us">
            <div class="footer-top-title font-16 tbc-bold">
              {{ $fn.tr("Across TBC") }}
            </div>
            <div class="link-items font-14">
              <template v-for="link in footerMenu('across_tbc')">
                <router-link
                  :to="link.full_url"
                  v-if="
                    !_.get(link, 'configs').includes('disable-from-menu') &&
                      !_.get(link, 'shortlink')
                  "
                  :key="link.id"
                  >{{ link.title }}</router-link
                >

                <a
                  :target="link.url_target"
                  :href="link.full_url"
                  v-if="
                    !_.get(link, 'configs').includes('disable-from-menu') &&
                      _.get(link, 'shortlink')
                  "
                  :key="link.id"
                  >{{ link.title }}</a
                >
              </template>
            </div>
            <div class="social">
              <div class="footer-top-title font-16 tbc-bold">
                {{ $fn.tr("Social Channels") }}
              </div>

              <div class="social-icons">
                <a
                  v-if="_.get(widgets.social, 'fb.url')"
                  :href="_.get(widgets.social, 'fb.url')"
                  target="_blank"
                >
                  <div class="hover-social-content br-4">
                    <span class="hover-social tbc-regular font-12">{{
                      _.get(widgets.social, "fb.hover_title")
                    }}</span>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20.234"
                    height="20.234"
                    viewBox="0 0 20.234 20.234"
                  >
                    <path
                      id="facebook-square-brands"
                      d="M18.066,32H2.168A2.168,2.168,0,0,0,0,34.168v15.9a2.168,2.168,0,0,0,2.168,2.168h6.2V45.355H5.522V42.117H8.367V39.649c0-2.807,1.671-4.358,4.231-4.358a17.238,17.238,0,0,1,2.508.219v2.755H13.693a1.619,1.619,0,0,0-1.826,1.749v2.1h3.107l-.5,3.238h-2.61v6.879h6.2a2.168,2.168,0,0,0,2.168-2.168v-15.9A2.168,2.168,0,0,0,18.066,32Z"
                      transform="translate(0 -32)"
                      fill="#7d8a98"
                    />
                  </svg>
                </a>

                <a
                  v-if="_.get(widgets.social, 'twitter.url')"
                  :href="_.get(widgets.social, 'twitter.url')"
                  target="_blank"
                >
                  <div class="hover-social-content br-4">
                    <span class="hover-social tbc-regular font-12">{{
                      _.get(widgets.social, "twitter.hover_title")
                    }}</span>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20.217"
                    height="20.217"
                    viewBox="0 0 20.217 20.217"
                  >
                    <path
                      id="Subtraction_111"
                      data-name="Subtraction 111"
                      d="M11540.888,16831.219h-9.56a5.413,5.413,0,0,1-5.326-5.445v-9.332a5.4,5.4,0,0,1,5.326-5.439h9.56a5.412,5.412,0,0,1,5.331,5.439v9.332A5.422,5.422,0,0,1,11540.888,16831.219Zm-10.956-5.674h0a8.121,8.121,0,0,0,4.414,1.293,7.783,7.783,0,0,0,4.676-1.42,8.6,8.6,0,0,0,3.5-6.758c0-.123,0-.25-.008-.371a6.082,6.082,0,0,0,1.44-1.488,5.755,5.755,0,0,1-1.656.443,2.85,2.85,0,0,0,1.268-1.584,5.717,5.717,0,0,1-1.825.7,2.879,2.879,0,0,0-4.976,1.967,3.464,3.464,0,0,0,.071.658,8.172,8.172,0,0,1-5.922-3.008,2.877,2.877,0,0,0,.887,3.844,2.853,2.853,0,0,1-1.3-.363v.035a2.869,2.869,0,0,0,2.3,2.82,2.938,2.938,0,0,1-.756.1,2.976,2.976,0,0,1-.541-.047,2.874,2.874,0,0,0,2.687,1.994,5.74,5.74,0,0,1-3.569,1.23A5.586,5.586,0,0,1,11529.932,16825.545Z"
                      transform="translate(-11526.002 -16811.002)"
                      fill="#7d8a98"
                    />
                  </svg>
                </a>

                <a
                  v-if="_.get(widgets.social, 'youtube.url')"
                  :href="_.get(widgets.social, 'youtube.url')"
                  target="_blank"
                >
                  <div class="hover-social-content br-4">
                    <span class="hover-social tbc-regular font-12">{{
                      _.get(widgets.social, "youtube.hover_title")
                    }}</span>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23.585"
                    height="20.216"
                    viewBox="0 0 23.585 20.216"
                  >
                    <path
                      id="Path_618"
                      data-name="Path 618"
                      d="M7.79,27.685a59.615,59.615,0,0,0,8,.531,59.617,59.617,0,0,0,8-.526,4.376,4.376,0,0,0,3.79-4.33V12.86a4.376,4.376,0,0,0-3.79-4.33,60.6,60.6,0,0,0-16,0A4.376,4.376,0,0,0,4,12.86v10.5A4.376,4.376,0,0,0,7.79,27.685ZM13.08,16.17a1.44,1.44,0,0,1,2.22-1.213l3.3,2.106a1.221,1.221,0,0,1,0,2.055l-3.3,2.106a1.44,1.44,0,0,1-2.22-1.213Z"
                      transform="translate(-4 -8)"
                      fill="#7d8a98"
                    />
                  </svg>
                </a>

                <a
                  v-if="_.get(widgets.social, 'linkdin.url')"
                  :href="_.get(widgets.social, 'linkdin.url')"
                  target="_blank"
                >
                  <div class="hover-social-content br-4">
                    <span class="hover-social tbc-regular font-12">{{
                      _.get(widgets.social, "linkdin.hover_title")
                    }}</span>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20.217"
                    height="20.217"
                    viewBox="0 0 20.217 20.217"
                  >
                    <path
                      id="Subtraction_110"
                      data-name="Subtraction 110"
                      d="M11540.888,16831.219h-9.56a5.413,5.413,0,0,1-5.326-5.445v-9.332a5.4,5.4,0,0,1,5.326-5.439h9.56a5.412,5.412,0,0,1,5.331,5.439v9.332A5.422,5.422,0,0,1,11540.888,16831.219Zm-1.952-10.721c1.259,0,1.259,1.193,1.259,2.064v3.8h2.421v-4.289c0-1.928-.352-3.709-2.9-3.709a2.547,2.547,0,0,0-2.289,1.26h-.038v-1.064h-2.323v7.8h2.42v-3.861C11537.482,16821.51,11537.655,16820.5,11538.936,16820.5Zm-7.814-1.939h0v7.8h2.425v-7.8Zm1.213-3.887a1.411,1.411,0,1,0,1.4,1.406A1.406,1.406,0,0,0,11532.334,16814.672Z"
                      transform="translate(-11526.002 -16811.002)"
                      fill="#7d8a98"
                    />
                  </svg>
                </a>

                <a
                  v-if="_.get(widgets.social, 'instagram.url')"
                  :href="_.get(widgets.social, 'instagram.url')"
                  target="_blank"
                >
                  <div class="hover-social-content br-4">
                    <span class="hover-social tbc-regular font-12">{{
                      _.get(widgets.social, "instagram.hover_title")
                    }}</span>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20.217"
                    height="20.217"
                    viewBox="0 0 20.217 20.217"
                  >
                    <path
                      id="Path_627"
                      data-name="Path 627"
                      d="M13.328,28.217h9.561a5.4,5.4,0,0,0,5.328-5.442V13.442A5.4,5.4,0,0,0,22.889,8H13.328A5.4,5.4,0,0,0,8,13.442v9.334a5.4,5.4,0,0,0,5.328,5.442ZM24,11.369a1.264,1.264,0,1,1-1.238,1.264A1.264,1.264,0,0,1,24,11.369Zm-5.9,1.685a5.054,5.054,0,1,1-4.949,5.054A5,5,0,0,1,18.108,13.054Z"
                      transform="translate(-8 -8)"
                      fill="#7d8a98"
                    />
                  </svg>
                </a>
              </div>

              <div class="social-info font-14 tbc-regular">
                {{ _.get(widgets.social, "title") }}
              </div>
            </div>
          </div>
          <div class="social">
            <div class="footer-top-title font-16 tbc-bold">
              {{ $fn.tr("Social Channels") }}
            </div>

            <!-- <div class="social-icons">
              <a
                v-if="_.get(widgets.social, 'fb.url')"
                :href="_.get(widgets.social, 'fb.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "fb.hover_title")
                  }}</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.234"
                  height="20.234"
                  viewBox="0 0 20.234 20.234"
                >
                  <path
                    id="facebook-square-brands"
                    d="M18.066,32H2.168A2.168,2.168,0,0,0,0,34.168v15.9a2.168,2.168,0,0,0,2.168,2.168h6.2V45.355H5.522V42.117H8.367V39.649c0-2.807,1.671-4.358,4.231-4.358a17.238,17.238,0,0,1,2.508.219v2.755H13.693a1.619,1.619,0,0,0-1.826,1.749v2.1h3.107l-.5,3.238h-2.61v6.879h6.2a2.168,2.168,0,0,0,2.168-2.168v-15.9A2.168,2.168,0,0,0,18.066,32Z"
                    transform="translate(0 -32)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>

              <a
                v-if="_.get(widgets.social, 'twitter.url')"
                :href="_.get(widgets.social, 'twitter.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "twitter.hover_title")
                  }}</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.217"
                  height="20.217"
                  viewBox="0 0 20.217 20.217"
                >
                  <path
                    id="Subtraction_111"
                    data-name="Subtraction 111"
                    d="M11540.888,16831.219h-9.56a5.413,5.413,0,0,1-5.326-5.445v-9.332a5.4,5.4,0,0,1,5.326-5.439h9.56a5.412,5.412,0,0,1,5.331,5.439v9.332A5.422,5.422,0,0,1,11540.888,16831.219Zm-10.956-5.674h0a8.121,8.121,0,0,0,4.414,1.293,7.783,7.783,0,0,0,4.676-1.42,8.6,8.6,0,0,0,3.5-6.758c0-.123,0-.25-.008-.371a6.082,6.082,0,0,0,1.44-1.488,5.755,5.755,0,0,1-1.656.443,2.85,2.85,0,0,0,1.268-1.584,5.717,5.717,0,0,1-1.825.7,2.879,2.879,0,0,0-4.976,1.967,3.464,3.464,0,0,0,.071.658,8.172,8.172,0,0,1-5.922-3.008,2.877,2.877,0,0,0,.887,3.844,2.853,2.853,0,0,1-1.3-.363v.035a2.869,2.869,0,0,0,2.3,2.82,2.938,2.938,0,0,1-.756.1,2.976,2.976,0,0,1-.541-.047,2.874,2.874,0,0,0,2.687,1.994,5.74,5.74,0,0,1-3.569,1.23A5.586,5.586,0,0,1,11529.932,16825.545Z"
                    transform="translate(-11526.002 -16811.002)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>

              <a
                v-if="_.get(widgets.social, 'youtube.url')"
                :href="_.get(widgets.social, 'youtube.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "youtube.hover_title")
                  }}</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.585"
                  height="20.216"
                  viewBox="0 0 23.585 20.216"
                >
                  <path
                    id="Path_618"
                    data-name="Path 618"
                    d="M7.79,27.685a59.615,59.615,0,0,0,8,.531,59.617,59.617,0,0,0,8-.526,4.376,4.376,0,0,0,3.79-4.33V12.86a4.376,4.376,0,0,0-3.79-4.33,60.6,60.6,0,0,0-16,0A4.376,4.376,0,0,0,4,12.86v10.5A4.376,4.376,0,0,0,7.79,27.685ZM13.08,16.17a1.44,1.44,0,0,1,2.22-1.213l3.3,2.106a1.221,1.221,0,0,1,0,2.055l-3.3,2.106a1.44,1.44,0,0,1-2.22-1.213Z"
                    transform="translate(-4 -8)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>

              <a
                v-if="_.get(widgets.social, 'linkdin.url')"
                :href="_.get(widgets.social, 'linkdin.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "linkdin.hover_title")
                  }}</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.217"
                  height="20.217"
                  viewBox="0 0 20.217 20.217"
                >
                  <path
                    id="Subtraction_110"
                    data-name="Subtraction 110"
                    d="M11540.888,16831.219h-9.56a5.413,5.413,0,0,1-5.326-5.445v-9.332a5.4,5.4,0,0,1,5.326-5.439h9.56a5.412,5.412,0,0,1,5.331,5.439v9.332A5.422,5.422,0,0,1,11540.888,16831.219Zm-1.952-10.721c1.259,0,1.259,1.193,1.259,2.064v3.8h2.421v-4.289c0-1.928-.352-3.709-2.9-3.709a2.547,2.547,0,0,0-2.289,1.26h-.038v-1.064h-2.323v7.8h2.42v-3.861C11537.482,16821.51,11537.655,16820.5,11538.936,16820.5Zm-7.814-1.939h0v7.8h2.425v-7.8Zm1.213-3.887a1.411,1.411,0,1,0,1.4,1.406A1.406,1.406,0,0,0,11532.334,16814.672Z"
                    transform="translate(-11526.002 -16811.002)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>

              <a
                v-if="_.get(widgets.social, 'instagram.url')"
                :href="_.get(widgets.social, 'instagram.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "instagram.hover_title")
                  }}</span>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.217"
                  height="20.217"
                  viewBox="0 0 20.217 20.217"
                >
                  <path
                    id="Path_627"
                    data-name="Path 627"
                    d="M13.328,28.217h9.561a5.4,5.4,0,0,0,5.328-5.442V13.442A5.4,5.4,0,0,0,22.889,8H13.328A5.4,5.4,0,0,0,8,13.442v9.334a5.4,5.4,0,0,0,5.328,5.442ZM24,11.369a1.264,1.264,0,1,1-1.238,1.264A1.264,1.264,0,0,1,24,11.369Zm-5.9,1.685a5.054,5.054,0,1,1-4.949,5.054A5,5,0,0,1,18.108,13.054Z"
                    transform="translate(-8 -8)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>
            </div> -->

            <div class="social-info font-14 tbc-regular social-info-third">
              <!-- {{ _.get(widgets.social, "title") }} -->
              <template v-for="link in footerMenu('navigation')">
                <router-link
                  :to="link.full_url"
                  v-if="
                    !_.get(link, 'configs').includes('disable-from-menu') &&
                      !_.get(link, 'shortlink')
                  "
                  :key="link.id"
                  >{{ link.title }}</router-link
                >
                <a
                  :target="link.url_target"
                  :href="link.full_url"
                  v-if="
                    !_.get(link, 'configs').includes('disable-from-menu') &&
                      _.get(link, 'shortlink')
                  "
                  :key="link.id"
                  >{{ link.title }}</a
                >
              </template>
            </div>
          </div>

          <div class="call-center">
            <div class="footer-top-title font-16 tbc-bold">
              {{ $fn.tr(widgets.support.title) }}
            </div>
            <a
              :href="`mailto:${widgets.support.email}`"
              class="font-12 email"
              >{{ widgets.support.email }}</a
            >
            <a :href="'tel:' + widgets.support.phone" class="call-phone">
              <a class="underline-link" :href="'tel:' + widgets.support.phone"
                >{{ widgets.support.phone }}
              </a>
            </a>
            <div class="call-hours">
              <div class="row">
                <p class="hours font-16">
                  {{ widgets.support.hotline }}
                </p>
              </div>
            </div>
            <div class="mobile-app">
              <p>{{ $fn.tr("Download Mobile App") }}</p>
            </div>
            <div class="link-items row1 font-14">
              <a
                :href="
                  _.get(
                    $store.state.main.indx,
                    'widgets.mobiel-app-links.mobile_app_android_link'
                  )
                "
                target="_blank"
              >
                <div class="icon">
                  <svg
                    id="Group_6313"
                    data-name="Group 6313"
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.471"
                    height="21.728"
                    viewBox="0 0 19.471 21.728"
                  >
                    <path
                      id="Path_3027"
                      data-name="Path 3027"
                      d="M27.641,20.415A1.693,1.693,0,0,0,27.25,21.6V40.284a1.692,1.692,0,0,0,.391,1.187l.062.061L38.151,31.066V30.82L27.7,20.353Z"
                      transform="translate(-27.25 -20.079)"
                      fill="#00d4ff"
                    />
                    <path
                      id="Path_3028"
                      data-name="Path 3028"
                      d="M38.319,32.435l-3.482-3.49V28.7L38.32,25.21l.078.045L42.525,27.6a1.284,1.284,0,0,1,0,2.44L38.4,32.391Z"
                      transform="translate(-23.937 -17.958)"
                      fill="#ffd000"
                    />
                    <g
                      id="Group_6312"
                      data-name="Group 6312"
                      transform="translate(0.389 10.864)"
                    >
                      <path
                        id="Path_3029"
                        data-name="Path 3029"
                        d="M41.593,31.292l-3.562-3.568L27.521,38.252a1.37,1.37,0,0,0,1.752.052Z"
                        transform="translate(-27.521 -27.724)"
                        fill="#f73447"
                      />
                    </g>
                    <path
                      id="Path_3030"
                      data-name="Path 3030"
                      d="M41.593,27.458,29.273,20.446a1.369,1.369,0,0,0-1.752.052l10.51,10.528Z"
                      transform="translate(-27.132 -20.163)"
                      fill="#01f076"
                    />
                  </svg>
                </div>
                <div class="text-cont">
                  <div class="textIcon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="71.494"
                      height="14.386"
                      viewBox="0 0 71.494 14.386"
                    >
                      <path
                        id="Path_3019"
                        data-name="Path 3019"
                        d="M68.338,29.961a3.593,3.593,0,1,0,3.6,3.593A3.539,3.539,0,0,0,68.338,29.961Zm0,5.771a2.184,2.184,0,1,1,2.024-2.178A2.077,2.077,0,0,1,68.338,35.732Zm-7.855-5.771a3.593,3.593,0,1,0,3.6,3.593A3.539,3.539,0,0,0,60.483,29.961Zm0,5.771a2.184,2.184,0,1,1,2.024-2.178A2.077,2.077,0,0,1,60.483,35.732Zm-9.342-4.668v1.524h3.642a3.179,3.179,0,0,1-.829,1.918,3.725,3.725,0,0,1-2.813,1.116,4.056,4.056,0,0,1,0-8.111A3.876,3.876,0,0,1,53.885,28.6l1.074-1.075a5.3,5.3,0,0,0-3.818-1.537,5.58,5.58,0,1,0,0,11.159,4.935,4.935,0,0,0,5.2-5.131,4.933,4.933,0,0,0-.082-.952H51.141Zm38.21,1.184a3.335,3.335,0,0,0-3.07-2.287A3.412,3.412,0,0,0,82.9,33.554a3.513,3.513,0,0,0,3.56,3.593,3.569,3.569,0,0,0,2.99-1.592l-1.223-.817a2.048,2.048,0,0,1-1.767.994,1.824,1.824,0,0,1-1.739-1.089l4.8-1.987Zm-4.891,1.2a1.969,1.969,0,0,1,1.876-2.1,1.39,1.39,0,0,1,1.332.762Zm-3.9,3.484h1.575V26.369H80.56Zm-2.582-6.165h-.054a2.483,2.483,0,0,0-1.888-.8,3.6,3.6,0,0,0,0,7.186,2.444,2.444,0,0,0,1.888-.816h.054v.517c0,1.374-.734,2.109-1.915,2.109a1.985,1.985,0,0,1-1.807-1.279l-1.372.572a3.419,3.419,0,0,0,3.179,2.123c1.848,0,3.411-1.089,3.411-3.743V30.18H77.979v.585Zm-1.806,4.968a2.186,2.186,0,0,1,0-4.355,2.2,2.2,0,0,1,0,4.355Zm20.561-9.363h-3.77v10.56h1.573v-4h2.2a3.284,3.284,0,1,0,0-6.56Zm.041,5.09H94.535v-3.62h2.238a1.81,1.81,0,1,1,0,3.62Zm9.725-1.516a2.953,2.953,0,0,0-2.807,1.617l1.4.584a1.492,1.492,0,0,1,1.438-.775,1.516,1.516,0,0,1,1.655,1.358v.109a3.479,3.479,0,0,0-1.641-.407c-1.505,0-3.039.829-3.039,2.377a2.437,2.437,0,0,0,2.618,2.323,2.218,2.218,0,0,0,2.007-1.033h.054v.815h1.52V32.862A2.893,2.893,0,0,0,106.5,29.942Zm-.191,5.787c-.514,0-1.234-.258-1.234-.9,0-.815.9-1.128,1.669-1.128a2.8,2.8,0,0,1,1.437.353A1.909,1.909,0,0,1,106.308,35.73Zm8.925-5.557-1.8,4.579h-.054L111.5,30.173h-1.7l2.808,6.4-1.6,3.56h1.641l4.327-9.959ZM101.06,36.929h1.573V26.369H101.06Z"
                        transform="translate(-45.489 -25.987)"
                        fill="#dadada"
                      />
                    </svg>
                  </div>
                </div>
              </a>
              <a
                :href="
                  _.get(
                    $store.state.main.indx,
                    'widgets.mobiel-app-links.mobile_app_ios_link'
                  )
                "
                target="_blank"
              >
                <div class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16.159"
                    height="19.96"
                    viewBox="0 0 16.159 19.96"
                  >
                    <path
                      id="Path_3052"
                      data-name="Path 3052"
                      d="M175.647,29.346A4.572,4.572,0,0,1,177.8,25.54a4.674,4.674,0,0,0-3.641-1.978c-1.532-.162-3.017.921-3.8.921-.8,0-2-.9-3.29-.878a4.886,4.886,0,0,0-4.08,2.5c-1.764,3.069-.448,7.58,1.241,10.061.846,1.215,1.833,2.572,3.126,2.524,1.266-.053,1.737-.811,3.264-.811s1.957.811,3.276.78c1.358-.022,2.213-1.22,3.029-2.447a10.067,10.067,0,0,0,1.385-2.835A4.42,4.42,0,0,1,175.647,29.346Z"
                      transform="translate(-162.15 -18.732)"
                      fill="#dadada"
                    />
                    <path
                      id="Path_3053"
                      data-name="Path 3053"
                      d="M170.709,23.394a4.479,4.479,0,0,0,1.017-3.2,4.513,4.513,0,0,0-2.925,1.521,4.294,4.294,0,0,0-1.043,3.081A3.772,3.772,0,0,0,170.709,23.394Z"
                      transform="translate(-159.705 -20.194)"
                      fill="#dadada"
                    />
                  </svg>
                </div>
                <div class="text-cont">
                  <div class="textIcon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="68.474"
                      height="14.41"
                      viewBox="0 0 68.474 14.41"
                    >
                      <path
                        id="Path_3031"
                        data-name="Path 3031"
                        d="M207.971,26.881v2.1h-1.309v1.377h1.309v4.679c0,1.6.72,2.237,2.529,2.237a5.222,5.222,0,0,0,.886-.084V35.829a5.325,5.325,0,0,1-.621.038c-.81,0-1.167-.38-1.167-1.248V30.358h1.787V28.981H209.6v-2.1Z"
                        transform="translate(-165.038 -25.572)"
                        fill="#dadada"
                      />
                      <path
                        id="Path_3032"
                        data-name="Path 3032"
                        d="M214.341,36.81c2.408,0,3.883-1.621,3.883-4.307,0-2.671-1.483-4.3-3.883-4.3s-3.891,1.628-3.891,4.3C210.45,35.19,211.926,36.81,214.341,36.81Zm0-1.453c-1.415,0-2.21-1.042-2.21-2.853,0-1.8.795-2.846,2.21-2.846s2.211,1.05,2.211,2.846S215.749,35.357,214.341,35.357Z"
                        transform="translate(-163.384 -24.994)"
                        fill="#dadada"
                      />
                      <path
                        id="Path_3033"
                        data-name="Path 3033"
                        d="M216.741,36.644h1.628V31.751a1.936,1.936,0,0,1,2.1-1.948,4.454,4.454,0,0,1,.909.1V28.289a3.425,3.425,0,0,0-.727-.068,2.236,2.236,0,0,0-2.225,1.408h-.122V28.358h-1.566Z"
                        transform="translate(-160.636 -24.988)"
                        fill="#dadada"
                      />
                      <path
                        id="Path_3034"
                        data-name="Path 3034"
                        d="M223.937,29.6a1.994,1.994,0,0,1,2.029,2.146H221.8A2.113,2.113,0,0,1,223.937,29.6Zm2.021,4.816a1.975,1.975,0,0,1-1.961,1,2.185,2.185,0,0,1-2.2-2.374v-.091h5.822v-.571c0-2.6-1.385-4.177-3.679-4.177-2.325,0-3.8,1.682-3.8,4.329s1.445,4.276,3.807,4.276a3.352,3.352,0,0,0,3.575-2.4Z"
                        transform="translate(-159.15 -24.994)"
                        fill="#dadada"
                      />
                      <path
                        id="Path_3035"
                        data-name="Path 3035"
                        d="M200.144,34.567c.125,2.035,1.812,3.336,4.323,3.336,2.684,0,4.363-1.364,4.363-3.541,0-1.711-.957-2.658-3.28-3.2l-1.247-.308c-1.476-.347-2.072-.812-2.072-1.625,0-1.025.925-1.7,2.315-1.7a2.165,2.165,0,0,1,2.394,1.7h1.71c-.1-1.916-1.782-3.265-4.08-3.265-2.471,0-4.119,1.349-4.119,3.375,0,1.672.934,2.666,2.981,3.147l1.46.355c1.5.355,2.158.875,2.158,1.743,0,1.009-1.036,1.743-2.448,1.743-1.514,0-2.566-.686-2.715-1.766Z"
                        transform="translate(-167.885 -25.971)"
                        fill="#dadada"
                      />
                      <path
                        id="Path_3036"
                        data-name="Path 3036"
                        d="M189.708,28.221a2.862,2.862,0,0,0-2.589,1.507H187v-1.37h-1.566V39.4h1.628v-4.01h.128a2.686,2.686,0,0,0,2.536,1.392c2.082,0,3.408-1.651,3.408-4.284S191.8,28.221,189.708,28.221Zm-.463,7.091c-1.362,0-2.218-1.08-2.218-2.808s.856-2.815,2.227-2.815,2.2,1.058,2.2,2.808S190.632,35.312,189.246,35.312Z"
                        transform="translate(-174.311 -24.988)"
                        fill="#dadada"
                      />
                      <path
                        id="Path_3037"
                        data-name="Path 3037"
                        d="M196.054,28.221a2.863,2.863,0,0,0-2.589,1.507h-.122v-1.37h-1.566V39.4H193.4v-4.01h.128a2.687,2.687,0,0,0,2.536,1.392c2.083,0,3.408-1.651,3.408-4.284S198.152,28.221,196.054,28.221Zm-.461,7.091c-1.363,0-2.218-1.08-2.218-2.808s.855-2.815,2.225-2.815,2.2,1.058,2.2,2.808S196.978,35.312,195.593,35.312Z"
                        transform="translate(-171.539 -24.988)"
                        fill="#dadada"
                      />
                      <path
                        id="Path_3038"
                        data-name="Path 3038"
                        d="M185.89,37.543h1.868l-4.089-11.38h-1.891l-4.088,11.38h1.8l1.043-3.02h4.316Zm-3.257-9.314h.134l1.641,4.811h-3.422Z"
                        transform="translate(-177.691 -25.887)"
                        fill="#dadada"
                      />
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="mobile-content">
            <div class="social-icons">
              <a
                v-if="_.get(widgets.social, 'fb.url')"
                :href="_.get(widgets.social, 'fb.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "fb.hover_title")
                  }}</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.234"
                  height="20.234"
                  viewBox="0 0 20.234 20.234"
                >
                  <path
                    id="facebook-square-brands"
                    d="M18.066,32H2.168A2.168,2.168,0,0,0,0,34.168v15.9a2.168,2.168,0,0,0,2.168,2.168h6.2V45.355H5.522V42.117H8.367V39.649c0-2.807,1.671-4.358,4.231-4.358a17.238,17.238,0,0,1,2.508.219v2.755H13.693a1.619,1.619,0,0,0-1.826,1.749v2.1h3.107l-.5,3.238h-2.61v6.879h6.2a2.168,2.168,0,0,0,2.168-2.168v-15.9A2.168,2.168,0,0,0,18.066,32Z"
                    transform="translate(0 -32)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>

              <a
                v-if="_.get(widgets.social, 'twitter.url')"
                :href="_.get(widgets.social, 'twitter.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "twitter.hover_title")
                  }}</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.217"
                  height="20.217"
                  viewBox="0 0 20.217 20.217"
                >
                  <path
                    id="Subtraction_111"
                    data-name="Subtraction 111"
                    d="M11540.888,16831.219h-9.56a5.413,5.413,0,0,1-5.326-5.445v-9.332a5.4,5.4,0,0,1,5.326-5.439h9.56a5.412,5.412,0,0,1,5.331,5.439v9.332A5.422,5.422,0,0,1,11540.888,16831.219Zm-10.956-5.674h0a8.121,8.121,0,0,0,4.414,1.293,7.783,7.783,0,0,0,4.676-1.42,8.6,8.6,0,0,0,3.5-6.758c0-.123,0-.25-.008-.371a6.082,6.082,0,0,0,1.44-1.488,5.755,5.755,0,0,1-1.656.443,2.85,2.85,0,0,0,1.268-1.584,5.717,5.717,0,0,1-1.825.7,2.879,2.879,0,0,0-4.976,1.967,3.464,3.464,0,0,0,.071.658,8.172,8.172,0,0,1-5.922-3.008,2.877,2.877,0,0,0,.887,3.844,2.853,2.853,0,0,1-1.3-.363v.035a2.869,2.869,0,0,0,2.3,2.82,2.938,2.938,0,0,1-.756.1,2.976,2.976,0,0,1-.541-.047,2.874,2.874,0,0,0,2.687,1.994,5.74,5.74,0,0,1-3.569,1.23A5.586,5.586,0,0,1,11529.932,16825.545Z"
                    transform="translate(-11526.002 -16811.002)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>

              <a
                v-if="_.get(widgets.social, 'youtube.url')"
                :href="_.get(widgets.social, 'youtube.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "youtube.hover_title")
                  }}</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.585"
                  height="20.216"
                  viewBox="0 0 23.585 20.216"
                >
                  <path
                    id="Path_618"
                    data-name="Path 618"
                    d="M7.79,27.685a59.615,59.615,0,0,0,8,.531,59.617,59.617,0,0,0,8-.526,4.376,4.376,0,0,0,3.79-4.33V12.86a4.376,4.376,0,0,0-3.79-4.33,60.6,60.6,0,0,0-16,0A4.376,4.376,0,0,0,4,12.86v10.5A4.376,4.376,0,0,0,7.79,27.685ZM13.08,16.17a1.44,1.44,0,0,1,2.22-1.213l3.3,2.106a1.221,1.221,0,0,1,0,2.055l-3.3,2.106a1.44,1.44,0,0,1-2.22-1.213Z"
                    transform="translate(-4 -8)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>

              <a
                v-if="_.get(widgets.social, 'linkdin.url')"
                :href="_.get(widgets.social, 'linkdin.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "linkdin.hover_title")
                  }}</span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.217"
                  height="20.217"
                  viewBox="0 0 20.217 20.217"
                >
                  <path
                    id="Subtraction_110"
                    data-name="Subtraction 110"
                    d="M11540.888,16831.219h-9.56a5.413,5.413,0,0,1-5.326-5.445v-9.332a5.4,5.4,0,0,1,5.326-5.439h9.56a5.412,5.412,0,0,1,5.331,5.439v9.332A5.422,5.422,0,0,1,11540.888,16831.219Zm-1.952-10.721c1.259,0,1.259,1.193,1.259,2.064v3.8h2.421v-4.289c0-1.928-.352-3.709-2.9-3.709a2.547,2.547,0,0,0-2.289,1.26h-.038v-1.064h-2.323v7.8h2.42v-3.861C11537.482,16821.51,11537.655,16820.5,11538.936,16820.5Zm-7.814-1.939h0v7.8h2.425v-7.8Zm1.213-3.887a1.411,1.411,0,1,0,1.4,1.406A1.406,1.406,0,0,0,11532.334,16814.672Z"
                    transform="translate(-11526.002 -16811.002)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>

              <a
                v-if="_.get(widgets.social, 'instagram.url')"
                :href="_.get(widgets.social, 'instagram.url')"
                target="_blank"
              >
                <div class="hover-social-content br-4">
                  <span class="hover-social tbc-regular font-12">{{
                    _.get(widgets.social, "instagram.hover_title")
                  }}</span>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.217"
                  height="20.217"
                  viewBox="0 0 20.217 20.217"
                >
                  <path
                    id="Path_627"
                    data-name="Path 627"
                    d="M13.328,28.217h9.561a5.4,5.4,0,0,0,5.328-5.442V13.442A5.4,5.4,0,0,0,22.889,8H13.328A5.4,5.4,0,0,0,8,13.442v9.334a5.4,5.4,0,0,0,5.328,5.442ZM24,11.369a1.264,1.264,0,1,1-1.238,1.264A1.264,1.264,0,0,1,24,11.369Zm-5.9,1.685a5.054,5.054,0,1,1-4.949,5.054A5,5,0,0,1,18.108,13.054Z"
                    transform="translate(-8 -8)"
                    fill="#7d8a98"
                  />
                </svg>
              </a>
            </div>
            <div class="terms-privacy">
              <router-link
                :to="link.full_url"
                v-for="link in this.getMenuFlat('footer_bottom', 0)"
                :key="link.id"
                >{{ link.title }}</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="container footer-content">
          <div class="footer-bottom-left">
            <div class="footer-logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100.667"
                height="41"
                viewBox="0 0 100.667 41"
              >
                <g
                  id="Group_6301"
                  data-name="Group 6301"
                  transform="translate(0.5 0.5)"
                >
                  <path
                    id="Subtraction_113"
                    data-name="Subtraction 113"
                    d="M99.667,40h-25V37.333H97V2.666H74.667V0h25V40ZM70,40H0V0H70V2.666H40V37.333H70V40ZM22.178,23.49a2.107,2.107,0,0,0-1.189.38c-.169.116-.34.251-.522.395l-.042.033a29.16,29.16,0,0,1-5.317,3.3,20.8,20.8,0,0,1-3.634,1.364c-.3.078-.319.16-.313.26a.184.184,0,0,0,.159.167c.756.14,6.772.331,9.6.331h.334a81.105,81.105,0,0,0,9.325-.523l.015,0h0a1.39,1.39,0,0,0,.336-.112.616.616,0,0,0,.31-.4.658.658,0,0,0-.138-.523,2.987,2.987,0,0,0-.563-.562,23.676,23.676,0,0,0-7.717-4.019,2.385,2.385,0,0,0-.642-.093ZM20.357,10.333a.194.194,0,0,0-.149.073c-.522.612-3.98,6.2-5.25,8.427a80.231,80.231,0,0,0-4.209,8.329,1.529,1.529,0,0,0-.077.363.577.577,0,0,0,.615.613c.029,0,.062,0,.1,0a3.176,3.176,0,0,0,.751-.2l.018-.007a23.7,23.7,0,0,0,7.341-4.668,2.1,2.1,0,0,0,.668-1.73c-.019-.224-.053-.46-.088-.7a29.14,29.14,0,0,1-.206-6.251,20.838,20.838,0,0,1,.635-3.826c.082-.3.02-.357-.069-.4A.165.165,0,0,0,20.357,10.333Zm1.459.35a.609.609,0,0,0-.548.406,3.177,3.177,0,0,0-.2.749l0,.019a23.635,23.635,0,0,0,.376,8.686A2.106,2.106,0,0,0,22.6,21.986c.208.1.434.187.652.274a29.239,29.239,0,0,1,5.522,2.948,20.816,20.816,0,0,1,3,2.461c.121.122.21.178.28.178a.176.176,0,0,0,.1-.037.184.184,0,0,0,.065-.222c-.271-.763-3.382-6.545-4.68-8.754a79.037,79.037,0,0,0-5.116-7.807,1.478,1.478,0,0,0-.275-.248A.686.686,0,0,0,21.816,10.683Z"
                    fill="#dbdbd9"
                    stroke="rgba(0,0,0,0)"
                    stroke-miterlimit="10"
                    stroke-width="1"
                  />
                  <path
                    id="Path_2938"
                    data-name="Path 2938"
                    d="M1245.692,775.2l-5.3,8.16-5.36-8.16h-1.28v14h1.08v-12.44l5.4,8.2h.36l5.36-8.2V789.2h1.06v-14Z"
                    transform="translate(-1159.086 -762.203)"
                    fill="#fff"
                  />
                  <path
                    id="Path_2939"
                    data-name="Path 2939"
                    d="M1136.821,775.2l-3.2,10.1-3.5-10.1h-1.72l-3.4,10.1-3.3-10.1h-2.96l5.14,14h2.24l1.7-4.36,1.46-4.46,1.48,4.42,1.74,4.4h2.24l5.04-14Z"
                    transform="translate(-1069.742 -762.203)"
                    fill="#fff"
                  />
                </g>
              </svg>
            </div>
            <div class="copyright tbc-medium font-16">
              {{ $fn.tr("© 2020 TBC Bank Group PLC. All rights reserved") }}
            </div>
          </div>
          <div class="footer-bottom-right">
            <router-link
              :to="link.full_url"
              class="copyright tbc-medium"
              v-for="link in this.getMenuFlat('footer_bottom', 0)"
              :key="link.id"
              >{{ link.title }}</router-link
            >

            <!-- <a href="https://www.connect.ge/" target="_blank" class="connect">
              {{ $fn.tr("Credits") }}
            </a> -->
            <template v-for="link in footerMenu('contact')">
              <router-link
                :to="link.full_url"
                v-if="!_.get(link, 'configs').includes('disable-from-menu')"
                :key="link.id"
                >{{ link.title }}</router-link
              >
            </template>
          </div>
        </div>
      </div>
    </footer>
  </intersect>
</template>

<script>
import Intersect from "vue-intersect";
import phoneIcon from "../../components/Icons/FooterPhone";
import mainMixin from "../../mixins/main";
export default {
  mixins: [mainMixin],
  components: {
    Intersect,
    phoneIcon
  },
  data() {
    return {
      animate: false
    };
  },
  computed: {
    widgets() {
      let widgetItems = this.$store.state.main?.indx?.widgets;
      return {
        support: widgetItems.footer_contact,
        social: widgetItems["social-channels"]
      };
    },
    navigationFooterMenu() {
      const footerMenu = this.getMenuFlat("footer", 0);
      return footerMenu.filter(menu => menu.configs?.includes("navigation"));
    }
  },
  methods: {
    footerMenu(confName) {
      const footerMenu = this.getMenuFlat("footer", 0);
      return footerMenu.filter(menu => menu.configs?.includes(confName));
    }
  }
};
</script>

<style scoped>
.connect {
  position: relative;
  overflow: hidden;
  text-decoration: underline;
}
.connect svg:hover {
  transform: translateX(25px);
}
.connect svg:hover .connect-g {
  opacity: 1;
}
.connect-g {
  transition: 0.6s ease;
  opacity: 0;
}

.connect-g .o {
  transition-delay: 0.4s;
}
.connect-g .n {
  transition-delay: 0.6s;
}
.connect-g .nn {
  transition-delay: 0.8s;
}
.connect-g .e {
  transition-delay: 1s;
}
.connect-g .c {
  transition-delay: 1.2s;
}
.connect-g .t {
  transition-delay: 1.4s;
}
body[data-theme="night"] .connect-logo path,
body[data-theme="night"] .connect-logo polygon,
body[data-theme="night"] .connect-logo rect {
  fill: #dadada;
}
.mobile-connect {
  display: none;
}
.connect .empty-div {
  position: absolute;
  width: 200px;
  height: 22px;
  top: 0;
  background: var(--primary);
  right: -210px;
  overflow: hidden;
}
.connect .connect-logo {
  cursor: pointer;
  transition: 0.6s ease;
  transform: translateX(140px);
}
footer {
  position: relative;
}
.footer-top {
  background-color: var(--primary);
  padding: 50px 0 200px 0;
}
.footer-bottom {
  background-color: var(--gray);
  padding: 0;
  height: 78px;
  display: flex;
}
.footer-content {
  display: flex;
  justify-content: space-between;
}
.footer-top-title {
  margin-bottom: 20px;
}
body[data-theme="night"] .footer-top-title {
  color: #ffffff;
}
.call-center {
  border-radius: 12px;
  width: 285px;
  height: 176px;
  padding: 0 25px;
  padding-left: 0;
  position: relative;
}
.call-center .link-items {
  margin-top: 27px;
}
.call-center .link-items .icon {
  margin-right: 10px;
}
.assistant {
  margin-bottom: 25px;
  max-width: 190px;
}

.call-center .social-icons {
  display: none;
}
.call-center .email {
  margin-bottom: 22px;
  display: block;
  line-break: anywhere;
}
.call-phone {
  display: flex;
  align-items: center;
}
.call-hours .row {
  display: flex;
  align-items: center;
}
.mobile-app {
  margin-top: 10px;
  margin-bottom: -10px;
}
@media (max-width: 1399px) {
  .mobile-app {
    padding-bottom: 30px;
  }
}

.call-hours .row.font-16 {
  margin-top: 13px;
}
.call-hours {
  display: flex;
  flex-direction: column;
}
.call-hours p {
  line-height: 24px;
  margin-top: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--oppositeColor);
  padding: 20px 50px 20px 20px;
  border-radius: 5px;
}
@media (max-width: 1399px) {
  .call-hours p {
    padding: 20px 30px 20px 20px;
  }
}
.terms-privacy {
  display: flex;
  flex-wrap: wrap;
}
.terms-privacy a {
  line-height: 24px;
  /* text-decoration: underline; */
}

.assistant-title,
.assistant {
  line-height: 24px;
  color: var(--secondary);
}
.get-in-touch a {
  color: var(--tbc-blue);
  line-height: 24px;
}
.get-in-touch {
  margin-left: -60px;
}
.link-items {
  display: flex;
  flex-direction: column;
}
.row1 {
  flex-direction: row;
  margin: 0;
}
.link-items a {
  line-height: 30px;
  font-size: 14px;
  transition: 0.3s;
}
.row1 a {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--oppositeColor);
  padding: 20px;
  border-radius: 5px;
  margin-right: 20px;
}
.connect-logo {
  height: 23px;
  width: 185px;
}
.link-items a.active,
.link-items a:hover {
  color: var(--tbc-blue);
}
.terms-privacy a,
.footer-bottom-right > div {
  transition: 0.6s;
}
.terms-privacy a:hover,
.footer-bottom-right > div:hover {
  color: var(--tbc-blue);
}

.footer-logo {
  display: flex;
  justify-content: center;
  border-radius: 5px;
  height: 33px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  transition: 0.3s ease;
}

.footer-bottom-left,
.footer-bottom-right {
  display: flex;
  align-items: center;
}
.footer-bottom-left {
  width: 76.5%;
}
.footer-bottom-right {
  margin-right: auto;
}
.footer-bottom-right a {
  font-size: 14px;
  width: max-content;
  margin: 8px;
}
.copyright {
  display: flex;
  margin-left: 30px;
  cursor: pointer;
}
.footer-bottom-right .copyright {
  /* text-decoration: underline; */
}
.social-icons a:not(:last-child) {
  margin-right: 15px;
}
.social-icons svg path {
  fill: #dadada;
  transition: 0.3s ease;
}
.social-icons a:hover svg path {
  fill: var(--tbc-blue);
  transition: 0.3s ease;
}
.social-icons a {
  position: relative;
}
.social-icons a:hover .hover-social-content {
  transform: scale(1);
  transition: 0.2s ease-out;
}
.hover-social-content {
  position: absolute;
  transform: scale(0);
  top: -38px;
  left: -32px;
  background-color: #737373;
  color: #ffffff;
  height: 23px;
  width: 79px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease-out;
}
.hover-social {
  position: relative;
  color: #ffffff;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s ease-out;
}

.social-icons a:hover .hover-social {
  opacity: 1;
  visibility: visible;
  transition: 0.2s ease-out 0.2s;
}
.hover-social:after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 3px solid #737373;
}

.social-info {
  margin-top: 12px;
  line-height: 18px;
  max-width: 189px;
}
.social-info-third {
  display: flex;
  flex-direction: column;
}
.social-info a {
  line-height: 30px;
  font-size: 14px;
  transition: 0.3s;
}
.social-info a:hover {
  color: var(--tbc-blue);
}
.mobile-content {
  display: none;
}
.terms-privacy a {
  /* text-decoration: underline; */
  font-size: 16px;
  color: var(--text-gray);
}
.around-us {
  padding-right: 0px;
}
.around-us .social {
  display: block;
  margin-top: 34px;
}
.around-us .social .social-info {
  display: none;
}
@media (min-width: 1023px) {
  .around-us .social {
    display: none;
  }
}

.social.desktop-version {
  display: none;
}
.call-phone a {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--oppositeColor);
  padding: 20px 57px 20px 20px;
  border-radius: 5px;
}
@media (max-width: 1399px) {
  .call-phone a {
    padding: 20px 40px 20px 20px;
  }
}
body[data-theme="night"] .call-hours .hours,
body[data-theme="night"] .assistant-title,
body[data-theme="night"] .phone-text {
  color: #cacaca;
}
body[data-theme="night"] .assistant,
body[data-theme="night"] .social-info {
  color: #c8c8c8;
}

@media (max-width: 1599px) {
  .footer-top {
    padding-top: 38px;
    padding-bottom: 200px;
  }
  .footer-bottom-right .copyright:last-child {
    margin-left: 48px;
  }
  .footer-bottom-right .copyright:first-child {
    margin-left: 0;
  }
}

@media (max-width: 1399px) {
  .footer-content > div:not(:last-child) {
    margin-right: 20px;
  }
  .call-center .link-items {
    margin-top: 5px;
  }
  .footer-top {
    padding-bottom: 250px;
  }
  .call-center {
    max-width: 210px;
  }
  .get-in-touch {
    margin-left: 0;
  }
  .around-us {
    padding-right: 35px;
  }
}

@media (max-width: 1023px) {
  .footer-bottom-right {
    margin-right: unset;
  }
  /* .mobile-connect {
    display: block;
    width: 36px;
    margin-left: 50px;
    overflow: hidden;
  }
  .mobile-connect svg {
    height: unset;
    width: 150px;
  } */
  .footer-content > div:not(:last-child) {
    margin-right: unset;
  }
  .get-in-touch {
    margin-left: 30px;
  }
  .social {
    margin-right: 0;
  }
  .social {
    display: none;
  }
  .social.desktop-version {
    display: block;
    margin-top: 18px;
  }
  .footer-top-title {
    margin-bottom: 18px;
    /*padding-right: 40px;*/
  }
  .call-hours {
    display: flex;
    flex-direction: column;
  }
  .call-center {
    min-width: 226px;
    height: unset;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    padding: 17px;
    margin-top: 0;
    padding-top: 0;
    width: fit-content;
  }
  .call-hours .hours {
    margin-top: 14px;
  }
  .call-phone {
    /* padding-bottom: 35px; */
  }
  .call-center .social-icons {
    display: block;
    position: absolute;
    bottom: -42px;
  }
  .social-icons .hover-social-content {
    display: none;
  }
  .assistant {
    margin-bottom: 0;
  }
}
@media (max-width: 768px) {
  .copyright {
    font-size: 13px;
  }
}
@media (max-width: 767px) {
  .social.desktop-version .footer-top-title,
  .mobile-content .social-icons {
    display: none;
  }
  .mobile-connect {
    margin-left: 0;
  }
  .footer-logo {
    border-radius: 3px;
  }
  .footer-top {
    padding-top: 35px;
  }
  .call-center {
    max-width: unset;
    align-items: flex-start;
    padding: 17px 0;
  }
  .get-in-touch,
  .around-us {
    margin-top: 0;
  }
  .footer-logo {
    margin-right: 20px;
  }

  .social {
    display: none;
  }
  .social-icons {
    position: unset;
  }
  .get-in-touch {
    margin-left: 0;
  }

  .call-phone {
    padding-bottom: 0;
  }
  .call-phone a {
    color: var(--secondary);
  }
  .footer-top .footer-content {
    flex-direction: column;
  }
  .call-center {
    margin-top: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .footer-content > div:not(:last-child) {
    margin-right: unset;
    margin-bottom: 23px;
  }

  .footer-content .around-us {
    margin-bottom: 34px;
  }
  .footer-top-title {
    margin-bottom: 25px;
  }
  .call-center .social-icons {
    display: none;
  }
  .mobile-content {
    display: flex;
    flex-direction: column;
  }
  .mobile-content .terms-privacy a:first-child {
    margin-right: 33px;
  }
  .mobile-content .social-icons {
    margin-bottom: 40px;
  }
  .footer-top {
    padding-bottom: 20px;
  }
  .footer-bottom-right {
    /*display: none;*/
    padding-right: 0;
  }
  .footer-bottom-right .copyright {
    display: none;
  }
  .footer-bottom-left {
    margin-bottom: unset !important;
  }
  .copyright {
    margin-left: unset;
    font-size: 16px;
    max-width: 200px;
  }
  .terms-privacy {
    margin-bottom: 0;
  }
  .footer-content > div.around-us {
    margin-bottom: 35px;
  }
  .footer-bottom .footer-bottom-left {
    display: flex;
    justify-content: space-between;
  }
  .footer-bottom {
    padding: 15px 0;
  }
}
@media (max-width: 414px) {
  .mobile-connect svg {
    height: 23px;
  }
}
@media (max-width: 413px) {
  .footer-bottom {
    padding: 0;
    height: 113px;
  }
  .footer-bottom .footer-bottom-left {
    margin-bottom: 16px !important;
  }
  .footer-logo {
    margin-right: 7px;
  }
  .footer-logo svg {
    width: 50px;
    margin-right: 15px;
  }
  .footer-content {
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-bottom-right {
    margin-left: 0px;
  }
  .footer-bottom .footer-bottom-left {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }
  .footer-content > .call-center {
    position: relative;
    padding: 0px;
  }
  .footer-content > div.call-center {
    margin-bottom: 50px;
  }
  .call-hours {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .footer-top {
    padding-top: 68px;
  }
}
</style>

<style>
.phonesvg svg {
  width: 23px;
  height: 23px;
}
.phonesvg path {
  fill: #575757;
}
body[data-theme="night"] .phonesvg path {
  fill: #dadada;
}
</style>
